import type { ReactNode } from 'react';
import styles from './notice.module.css';

/**
 * Notice - a refusal's message, shown where the act was taken (docs/LOADING.md
 * §1 "Notice", §2 tool 8). One quiet line in `--alarm-text` at `--text-2xs`,
 * announced politely (`role="status"`). It stays until the person's next
 * gesture in that place or until they leave the surface: the owner clears it,
 * never a timer, and never a toast in a corner.
 *
 * Inline by default (a `span` on a checklist line, on the item's state line);
 * `block` for a notice that stands on its own row (under a list).
 */
export function Notice({
  children,
  block = false,
  className,
  testId,
}: {
  children: ReactNode;
  /** A paragraph of its own instead of a run of text in a row. */
  block?: boolean;
  className?: string;
  testId?: string;
}) {
  const Tag = block ? 'p' : 'span';
  return (
    <Tag
      className={className ? `${styles.notice} ${className}` : styles.notice}
      role="status"
      data-testid={testId}
    >
      {children}
    </Tag>
  );
}
